export default "__VITE_ASSET__C4SoyWCs__"